// Base URL for static site content (landing page, about us, login, intro video)
// stored in Cloudflare R2. Admins can replace a file in the bucket at the same
// key to update the site without a code change/redeploy.
export const R2_MEDIA_BASE_URL = process.env.CLOUDFLARE_R2_MEDIA_PUBLIC_URL || 'https://pub-bf85a07db031455791a5f0e231644835.r2.dev';
